export const USER_TYPE_CHANGE_KEY = 'n23j4o3i2j4o2i34';
